module.exports = "/images/vendor/flag-icon-css/flags/4x3/ca.svg?c976442e32a435a0ea72b42d40dbe8ef";